import { render, staticRenderFns } from "./ListVamRequests.vue?vue&type=template&id=b5229a7a&scoped=true&"
import script from "./ListVamRequests.vue?vue&type=script&lang=js&"
export * from "./ListVamRequests.vue?vue&type=script&lang=js&"
import style0 from "./ListVamRequests.vue?vue&type=style&index=0&id=b5229a7a&scoped=true&lang=css&"
import style1 from "./ListVamRequests.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5229a7a",
  null
  
)

export default component.exports